import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  static targets = ["feedback"]

  copy() {
    navigator.clipboard.writeText(this.textValue)
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.classList.remove("hidden")
      clearTimeout(this._feedbackTimer)
      this._feedbackTimer = setTimeout(() => this.feedbackTarget.classList.add("hidden"), 4000)
    }
  }
}
